module.exports = __webpack_public_path__ + "static/media/PHP_logo.12a0e88c.png";